import { createNode, TemporalValueUnion } from '@glueapp/graph-types';
import { objectToTemporal } from '../../utils/temporal';

export const FormatDateTime = createNode({
    id: 'Format Date/Time (ISO)',
    name: 'Format Date/Time (ISO)',
    description: 'Formats a Date, Time, DateTime, or ZonedDateTime as an ISO 8601 string',
    aiDescription:
        'Takes a temporal value (Date, Time, DateTime, or ZonedDateTime) on the "Value" port and outputs its ISO 8601 string representation on the "ISO String" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Value: { kind: 'generic', identifier: 'T', extends: TemporalValueUnion },
    },
    outPorts: {
        'ISO String': { kind: 'string' },
    },
    execute: function (input) {
        const temporal = objectToTemporal(input.inPorts.Value);
        return { output: { 'ISO String': temporal.toString() } };
    },
});
